import { ErrorLogComponent } from '@cian/error-log-component';
import { Microfrontend } from '@cian/mf-react';
import type { ICianMFUIElement } from '@cian/mf-registry/browser';
import { useEffect, useRef } from 'react';

import { ECalculatorEvent } from 'shared/constants/calculatorEvents';
import { ETelemetryEventType } from 'shared/types/telemetry';
import { IWidgetManifest } from 'shared/types/widgetManifest';
import { useApplicationContext } from 'shared/utils/applicationContext';

import { ERuntimeSettings } from '../../../types/runtimeSettings';

interface ICalculatorMicrofrontendProps {
  onSubmitCalculatorEvent(e: CustomEvent): void;
  onCatchErrorCalculatorEvent(e: CustomEvent): void;
  onSendAnalyticsCalculatorEvent(e: CustomEvent): void;
}
/* istanbul ignore next */
export const CalculatorMicrofrontend = ({
  onSubmitCalculatorEvent,
  onCatchErrorCalculatorEvent,
  onSendAnalyticsCalculatorEvent,
}: ICalculatorMicrofrontendProps) => {
  const { config, logger, telemetry } = useApplicationContext();
  const mcfRef = useRef<ICianMFUIElement>(null);
  const manifest = config.get<IWidgetManifest>(ERuntimeSettings.offerCalculatorManifest);

  useEffect(() => {
    if (mcfRef?.current) {
      mcfRef.current.addEventListener(ECalculatorEvent.onSubmit, onSubmitCalculatorEvent);
      mcfRef.current.addEventListener(ECalculatorEvent.onError, onCatchErrorCalculatorEvent);
      mcfRef.current.addEventListener(ECalculatorEvent.onAnalytics, onSendAnalyticsCalculatorEvent);
    }
  }, [mcfRef, onSubmitCalculatorEvent, onCatchErrorCalculatorEvent, onSendAnalyticsCalculatorEvent]);

  useEffect(() => {
    if (!manifest) {
      telemetry.increment(ETelemetryEventType.OfferCalculatorRenderError);
    }
  }, [manifest, telemetry]);

  if (!manifest) {
    logger.error('Отсутствует манифест микрофронта Ипотечного Калькулятора offer-calculator', {
      domain: 'microfrontends.offer-calculator.manifest',
    });

    return null;
  }

  return (
    <ErrorLogComponent
      logger={logger}
      onError={() => {
        telemetry.increment(ETelemetryEventType.OfferCalculatorRenderError);
      }}
    >
      <Microfrontend {...manifest} ref={mcfRef} />
    </ErrorLogComponent>
  );
};
